import React, { Component, Suspense, useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Spin, ConfigProvider } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import TheLayoutAdmin from "./container/TheLayoutAdmin";
import ThePublicLayout from "./container/ThePublicLayout";
import TheLoginLayout from "./container/TheLoginLayout";
import AdminRouteContent from "./components/admin/AdminRouteContent";
import { AdminInternal, AppInternal } from "./routes";


// ✅ This functional component contains your routing and logic
const Index = () => {
  const token = useSelector((state) => state.authReducer.token);
  const { user } = useSelector((state) => state.authReducer);

  useEffect(() => {
    const handleForceLogout = () => {
      toast.error("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại");
      setTimeout(() => {
        window.location.href = "/login";
      }, 1500);
    };

    window.addEventListener("force-logout", handleForceLogout);
    return () => window.removeEventListener("force-logout", handleForceLogout);
  }, []);

  return (
    <Suspense
      fallback={
        <div className="loading-web">
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 48,
                  color: "#fff",
                }}
                spin
              />
            }
          />
        </div>
      }
    >
      <ToastContainer />
      <Routes>
        {/* 🟢 Login route */}
        <Route
          path="/login"
          element={
            token && user.role === "Admin" ? (
              <Navigate to="/dashboard" />
            ) : (
              <TheLoginLayout />
            )
          }
        />

        {/* 🟢 Public routes */}
        <Route exact path="/" element={<ThePublicLayout />}>
          {AppInternal.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              element={<route.component />}
            />
          ))}
        </Route>

        {/* 🟢 Admin routes */}
        <Route
          path="/"
          element={
            token && user.role === "Admin" ? (
              <TheLayoutAdmin />
            ) : (
              <Navigate to="/login" />
            )
          }
        >
          {AdminInternal.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              element={<AdminRouteContent page={route.component} />}
            />
          ))}
        </Route>

        {/* 🟢 Fallback */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Suspense>
  );
};


// ✅ Wrap everything in Ant Design ConfigProvider
class App extends Component {
  render() {
    return (
      <ConfigProvider
        theme={{
          token: {
            borderRadius: 0,
          },
        }}
      >
        <BrowserRouter>
          <Index />
        </BrowserRouter>
      </ConfigProvider>
    );
  }
}

export default App;
